import React, { useState } from "react";
import useCollapse from 'react-collapsed';

import LottoPrize from "components/lotto/default/LottoPrize";
import DirectAdsComponent from "../../../components/lotto/default/DirectAdsComponent";
import CollapsibleHeader from "./CollapsibleHeader";

export function PrizeCollapsible({ topic, prizeDataArray, slug, isShowAtRender }) {
  const [isExpanded, setExpanded] = useState(isShowAtRender);
  const { getCollapseProps, getToggleProps } = useCollapse({ isExpanded });

  function handleOnClick() {
    setExpanded(!isExpanded);
  }

  return (
    <section className="collapsible" aria-label={topic}>
      <div
        className={isExpanded ? "header-expand" : "header-collapse"}
        {...getToggleProps({ onClick: handleOnClick })}
      >
        <CollapsibleHeader
          topic={topic}
          isExpanded={isExpanded}
          subtitle="รางวัลที่หนึ่ง · สองตัวล่าง"
        />
      </div>
      <div {...getCollapseProps()}>
        <div className="collapsible-panel">
          <p className="collapsible-intro">
            เช็คหวยรางวัลที่หนึ่ง และรางวัลสองตัวล่าง งวดปัจจุบันและย้อนหลัง
          </p>
          <div className="collapsible-scroll">
            <LottoPrize prizeDataArray={prizeDataArray} slug={slug} />
          </div>
          <DirectAdsComponent adsType="shopee" />
        </div>
      </div>
    </section>
  );
}
